import { PracticeMappingHandler } from '../../../mappings/practices';

export class PraktikaPracticeMappingHandler extends PracticeMappingHandler {}
